import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import DxDataTable from 'components/DxDataTable'
import { useStatisticShop } from 'sections/statistics/pages/ShopStatistic/hooks/useStatisticShop'
import { ContentBlockLoading } from 'components/ContentBlock'

export default function StatisticData() {
	const [t] = useTranslation()
	const { customData, dispatchCustomData, statisticsDataReceived } = useStatisticShop()
	const { newData, newDataColumns, savedSettings } = customData
	const { status, loading, called } = statisticsDataReceived

	return called ?
		<Fragment>
			<ContentBlockLoading blockId='1' alwaysExpanded isLoading={loading} showHeader={false}>
				<DxDataTable
					data={newData}
					columns={newDataColumns}
					settings={savedSettings}
					height={508}
					label={t('statistic_section.sub_sections.shop_statistic')}
					manualGroup
					customStoring
					withSearch={false}
					excelExport
					onSaveSettings={(value) => dispatchCustomData({ type: 'savedSettings', value })}
					{...status === 'ERROR' && { noDataText: t('server_errors.request_failed') }}
				/>
			</ContentBlockLoading>
		</Fragment> : <></>
}
